package com.bulut.mecitogullari.core.tenant

import com.bulut.mecitogullari.data.repository.ProfileRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

/**
 * The tenant's own company name (Profil → Firma Adı), mirrored from Firestore
 * so non-compose code — printable reports above all — can brand output with
 * the user's company instead of a hard-coded name. Blank until the user sets
 * one; every consumer must handle that.
 */
object CompanyProfile {

    private val scope = CoroutineScope(SupervisorJob())

    private val _name = MutableStateFlow("")
    val name: StateFlow<String> = _name.asStateFlow()

    /** Call once at startup, after Koin is up. */
    fun start(repository: ProfileRepository) {
        scope.launch {
            repository.companyName.collect { _name.value = it }
        }
    }
}
